import { mapActions } from 'vuex';

export const setBreadcrumbsMixin = {
  methods: mapActions("app", ["setBreadcrumbs"])
}